module.exports = __webpack_public_path__ + "static/media/SPADE-9.479de739.svg";